import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import "./TestRuleTable.css";
import searchruleIcon from "../../../../common/assets/images/searchrule.png";
import testRuleEditIcon from "../../../../assets/testrule_edit_icon.png";
import testRuleRefreshIcon from "../../../../assets/test_rule_refresh.png";
import testRuleIcon from "../../../../assets/test_rule_icon.png";
import { debounce } from "lodash";
import { useNavigate } from "react-router-dom";
import {
  deleteTestRule,
  getAllTestRules,
  getPathwayFilterOptions,
  getRuleIDStatusRepsone,
  getTestRuleDetails,
  setTestRuleFilters,
} from "../TestRuleRedux";
import { useSelector, useDispatch } from "react-redux";
import { Spinner } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import { Tooltip } from "@mui/material";
import PublishStatusModal from "../../PublishedRule/PublishStatusModal";

// Rule Deleted successfully
 function ActionMenu({rowId, openId, setOpenId, status, onTestRule, onViewRule, onDelete, onEditRule }) {
      const open = openId === rowId; // was: const [open, setOpen] = useState(false);
    const [menuPosition, setMenuPosition] = useState(null);

    useEffect(() => {
      function handleClickOutside(e) {
        if (!e.target.closest(".testRules-actionMenu")) {
          setOpenId(null);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }, [setOpenId]);

    return (
      <div className="testRules-actionMenu">
        <button
          type="button"
          className="testRules-actionMenu-trigger"
          aria-label="Row actions"
          onClick={(e) => {
            if (open) {
              setOpenId(null);
              setMenuPosition(null);
            } else {
              const rect = e.currentTarget.getBoundingClientRect();
              setMenuPosition({
                top: rect.bottom + 4,
                right: window.innerWidth - rect.right,
              });
              setOpenId(rowId);
            }
          }}
        >
          &#8942;
        </button>

        {open && menuPosition && (
          <div
            className="testRules-actionMenu-dropdown"
            style={{ top: menuPosition.top, right: menuPosition.right }}
          >
            {status === "FAILED" ? (
              <button
                type="button"
                className="testRules-actionMenu-item"
                onClick={() => {
                  setOpenId(null);
                  onViewRule();
                }}
              >
                <span className="testRules-actionMenu-icon" aria-hidden="true">
                  &#128065;
                </span>
                View
              </button>
            ) : (
              <>
                <button
                  type="button"
                  className="testRules-actionMenu-item testRules-actionMenu-item--primary"
                  onClick={() => {
                    setOpenId(null);
                    onTestRule();
                  }}
                >
                  <span
                    className="testRules-actionMenu-icon"
                    aria-hidden="true"
                  >
                    <img src={testRuleIcon} />
                  </span>
                  Test Rule
                </button>
                <button
                  type="button"
                  className="testRules-actionMenu-item testRules-actionMenu-item--primary"
                  onClick={() => {
                    setOpenId(null);
                    onEditRule();
                  }}
                >
                  <span
                    className="testRules-actionMenu-icon"
                    aria-hidden="true"
                  >
                    <img src={testRuleEditIcon} />
                  </span>
                  Edit
                </button>
              </>
            )}

            <button
              type="button"
              className="testRules-actionMenu-item testRules-actionMenu-item--danger"
              onClick={() => {
                setOpenId(null);
                onDelete();
              }}
            >
              <span className="testRules-actionMenu-icon" aria-hidden="true">
                &#128465;
              </span>
              Delete
            </button>
          </div>
        )}
      </div>
    );
  }

export default function TestRuleTable({ onTestRule, onViewRule }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("All Statuses");
  const [pathwayFilter, setPathwayFilter] = useState("Pathway Entry Point");
  const [searchType, setSearchType] = useState("Search_by_rule_ID"); // 'episode' | 'mrn'
  const [coderSearchTerm, setCoderSearchTerm] = useState("");
  const [showOptions, setShowOptions] = useState(false);
  const [openActionMenuId, setOpenActionMenuId] = useState(null);
  const [showPublishModal, setShowPublishModal] = useState(false);
  const [publishModalType, setPublishModalType] = useState("loading");
  const [ruleStatusResponse, setRuleStatusResponse] = useState(null);
  

  const {
    loading: pathwayFilterOptionsLoading,
    data: pathwayFilterOptionsData,
    error: pathwayFilterOptionsError,
  } = useSelector((state) => state.testRule.pathwayFilterOptions);
  const {
    loading: allTestRulesLoading,
    data: allTestRulesData,
    error: allTestRulesError,
  } = useSelector((state) => state.testRule.allTestRulesResponse);
  const allTestRulesPayload = useSelector(
    (state) => state.testRule.allTestRulesPayload,
  );

  // console.log(allTestRulesData?.data, "allTestRulesData");
  const STATUS_OPTIONS = ["All Statuses", "For Testing", "Failed"];

  const PATHWAY_OPTIONS =
    pathwayFilterOptionsData?.data?.map((item) => item.value) || [];

  function StatusBadge({ status }) {
    if (status === "FOR_TESTING") {
      return (
        <span className="testRules-status-badge testRules-status-badge--testing">
          For Testing
        </span>
      );
    }
    if (status === "FAILED") {
      return (
        <span className="testRules-status-badge testRules-status-badge--failed">
          Failed
        </span>
      );
    }
    return "No Status";
  }

  function Dropdown({ options, value, onChange }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
      function handleClickOutside(e) {
        if (ref.current && !ref.current.contains(e.target)) {
          setOpen(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
      <div className="testRules-dropdown" ref={ref}>
        <button
          type="button"
          className="testRules-dropdown-trigger"
          onClick={() => setOpen((prev) => !prev)}
        >
          {value}
          <span className="testRules-dropdown-chevron" aria-hidden="true">
            &#9662;
          </span>
        </button>
        {open && (
          <div className="testRules-dropdown-menu">
            {options.map((opt) => (
              <button
                type="button"
                key={opt}
                className={
                  "testRules-dropdown-item" +
                  (opt === value ? " testRules-dropdown-item--selected" : "")
                }
                onClick={() => {
                  onChange(opt);
                  setOpen(false);
                }}
              >
                {opt}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  }
 
  const debounceSearchHandler = useCallback(
    debounce((payload) => {
      dispatch(getAllTestRules(payload));
    }, 1000),
    [],
  );
  const handleSearchTypeChange = (type) => {
    setSearchType(type);
    setShowOptions(false);

    dispatch(
      setTestRuleFilters({
        ...allTestRulesPayload,
        rule_id: [],
        description: [],
        trigger_code: [],
        page_number: 1,
      }),
    );
  };

  const handleSearchEpisode = (e) => {
    const rawValue = e.target.value;
    setCoderSearchTerm(rawValue);
    const cleanedValue = rawValue?.trim()?.replace(/\s+/g, " ");
    const isSearching = rawValue?.length > 0;

    const payload = {
      ...allTestRulesPayload,
      page_number: 1,
      rule_id: searchType === "Search_by_rule_ID" ? rawValue : [],
      description:
        searchType === "description" ? (rawValue ? rawValue : []) : [],
      trigger_code:
        searchType === "trigger_code" ? (rawValue ? rawValue : []) : [],
    };
    setShowOptions(false);

    dispatch(setTestRuleFilters(payload));
    const APIpayload = {
      ...allTestRulesPayload,
      page_number: 1,
      rule_id:
        searchType === "Search_by_rule_ID" && cleanedValue
          ? [cleanedValue]
          : [],
      description:
        searchType === "description" && cleanedValue ? [cleanedValue] : [],
      trigger_code:
        searchType === "trigger_code" && cleanedValue ? [cleanedValue] : [],
    };
    debounceSearchHandler(APIpayload);
  };

  useEffect(() => {
    const fetchPathwayOptions = async () => {
      let page = 1;
      const count = 10;

      while (true) {
        const response = await dispatch(
          getPathwayFilterOptions({
            page,
            count,
          }),
        ).unwrap();
        if (!response?.has_more) {
          break;
        }

        page++;
      }
    };
    fetchPathwayOptions();
      const allTestRulesPayload= { 
        rule_id: [], 
        description: [], 
        trigger_code: [], 
        status: [], 
        pathway_entry: [], 
        page_number: 1, 
        page_size:10, 
        sort_by: [], 
        sort_order: [] 
    }
    dispatch(getAllTestRules(allTestRulesPayload));
    dispatch(setTestRuleFilters(allTestRulesPayload));
  }, [dispatch]);

  const dataToDisplay = allTestRulesData?.data || [];

  const totalAllRulesCount = allTestRulesData?.total_count || 0;

  const pageSize = 10;

  const currentRulePage = allTestRulesData?.page_number || 1;

  const totalRulesPages = Math.ceil(totalAllRulesCount / pageSize);

  const startRule =
    totalAllRulesCount === 0 ? 0 : (currentRulePage - 1) * pageSize + 1;

  const endRule = Math.min(currentRulePage * pageSize, totalAllRulesCount);

  const cardBorderColors = {
  rules_requiring_testing: "#005EB8",
  passed_rules: "",
  failed_rules: "#EF4444",
};

const cardKeyMap = {
  "Rules Requiring Testing": "rules_requiring_testing",
  "Passed Rules": "passed_rules",
  "Failed Rules": "failed_rules",
};

const testRuleCardKeys = [
  "Rules Requiring Testing",
  "Passed Rules",
  "Failed Rules",
];

const wait = (ms) =>
    new Promise((resolve) => setTimeout(resolve, ms));
  
    const pollRuleStatus = async (jobId) => {
    if (!jobId) {
      setRuleStatusResponse({
        items: [
          {
            status: "FAILED",
            error_message: "Job ID was not returned.",
          },
        ],
      });
      setPublishModalType("result");
      setShowPublishModal(true);
      return;
    }
  
    while (true) {
      try {
        const result = await dispatch(
          getRuleIDStatusRepsone(jobId)
        ).unwrap();
  
        console.log(result, "status API response");
  
        const items = result?.items || [];
  
        const isCompleted =
          items.length > 0 &&
          items.every(
            (item) =>
              item?.status === "COMPLETED" ||
              item?.status === "FAILED"
          );
  
        if (isCompleted) {
          setRuleStatusResponse(result);
          setPublishModalType("result");
          setShowPublishModal(true);
          return;
        }
  
        await wait(5000);
      } catch (error) {
        console.error("Status API failed:", error);
  
        setRuleStatusResponse({
          items: [
            {
              status: "FAILED",
              error_message: "Failed to fetch rule status.",
            },
          ],
        });
  
        setPublishModalType("result");
        setShowPublishModal(true);
        return;
      }
    }
  };
      function formatDate(dateStr) {
  if (!dateStr) return "-";
  const d = new Date(dateStr);
  if (isNaN(d)) return dateStr;
  const datePart = d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  const timePart = d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false });
  return `${datePart}, ${timePart} (UTC)`;

}
  return (
    <div className="testRules-page">
      <ToastContainer position="top-right" autoClose={3000} />
      {/* Header */}
      <div className="testRules-header">
        <h1 className="testRules-title">Test Rules</h1>
        <p className="testRules-subtitle">
          Review and validate rules submitted for testing before production
          deployment.
        </p>
      </div>

      {/* Stat cards */}
      <div className="testRules-stats">
  {testRuleCardKeys.map((key) => {
    const apiKey = cardKeyMap[key];

    return (
      <div
        className="testRules-stat-card"
        key={key}
        style={{
          borderLeft: `3px solid ${
            apiKey === "rules_requiring_testing"
              ? "#005EB8"
              : apiKey === "failed_rules"
                ? "#EF4444"
                : "none"
          }`,
          backgroundColor:
      apiKey === "passed_rules"
        ? "#D6E3FF"
        : "transparent",
        }}
      >
        <div className="testRules-stat-label">
          {key}
        </div>

        <div className="testRules-stat-value">
          {allTestRulesLoading
            ? 0
            : allTestRulesData?.cards?.[apiKey] ?? 0}
        </div>
      </div>
    );
  })}
</div>

      {/* Toolbar */}
      <div className="testRules-toolbar">
        <div className="testRules-search">
          <img
            src={searchruleIcon}
            alt="search"
            style={{ height: "18px", paddingLeft: "5px" }}
          />
          <input
            className="testRules-search-input"
            value={coderSearchTerm}
            placeholder={
              searchType === "Search_by_rule_ID"
                ? "Search by Rule ID"
                : searchType === "description"
                  ? "Search by Description"
                  : searchType === "trigger_code" && " Search by trigger code"
            }
            onFocus={() => setShowOptions(true)}
            onBlur={() => setTimeout(() => setShowOptions(false), 150)}
            onChange={handleSearchEpisode}
          />
          {showOptions && (
            <div className="search-options-dropdown">
              <div
                className={`search-option ${searchType === "Search_by_rule_ID" ? "active" : ""}`}
                onMouseDown={() => handleSearchTypeChange("Search_by_rule_ID")}
              >
                Search by rule ID
              </div>

              <div
                className={`search-option ${searchType === "description" ? "active" : ""}`}
                onMouseDown={() => handleSearchTypeChange("description")}
              >
                Search by Description
              </div>

              <div
                className={`search-option ${searchType === "trigger_code" ? "active" : ""}`}
                onMouseDown={() => handleSearchTypeChange("trigger_code")}
              >
                Search by trigger code
              </div>
            </div>
          )}
        </div>
        <div className="testRules-filters">
          <Dropdown
            options={STATUS_OPTIONS}
            value={statusFilter}
            onChange={(selectedOption) => {
              const selectedStatus = selectedOption;
              setStatusFilter(selectedStatus);
              const testRuleStatusPayload = {
                ...allTestRulesPayload,
                page_number: 1,
                status:
                  selectedStatus === "All Statuses" ? [] : [selectedStatus],
              };
              dispatch(getAllTestRules(testRuleStatusPayload));
              dispatch(setTestRuleFilters(testRuleStatusPayload));
            }}
          />
          <Dropdown
            options={PATHWAY_OPTIONS}
            value={pathwayFilter}
            onChange={(selectedOption) => {
              const selectedPathWay = selectedOption;
              setPathwayFilter(selectedPathWay);
              const testRulePathwayPayload = {
                ...allTestRulesPayload,
                page_number: 1,
                pathway_entry: [selectedPathWay],
              };
              dispatch(getAllTestRules(testRulePathwayPayload));
              dispatch(setTestRuleFilters(testRulePathwayPayload));
            }}
          />
            <div
            className="testRules-refresh-icon"
            onClick={() => {
              const testRuleRefershPayload = {
                rule_id: [],
                description: [],
                trigger_code: [],
                status: [],
                pathway_entry: [],
                page_number: 1,
                page_size: 10,
                sort_by: [],
                sort_order: [],
              };
              dispatch(getAllTestRules(testRuleRefershPayload));
              dispatch(setTestRuleFilters(testRuleRefershPayload));
              setStatusFilter("All Statuses");
              setPathwayFilter("Pathway Entry Point");
            }}
          >
            <img src={testRuleRefreshIcon} />
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="testRules-table-wrap">
        <div className="testRules-table-scroll">
          <table className="testRules-table">
            <thead>
              <tr>
                <th>Rule ID</th>
                <th>Rule Description</th>
                <th>Pathway Entry Point</th>
                <th>Trigger Codes</th>
                <th>Created By</th>
                <th>Created On</th>
                <th>Status</th>
                <th className="testRules-th-action">Action</th>
              </tr>
            </thead>
            <tbody>
              {allTestRulesLoading ? (
                <tr>
                  <td colSpan="8">
                    <div className="episodelist-table-loader">
                      <Spinner />
                    </div>
                  </td>
                </tr>
              ) : allTestRulesError ? (
                <tr>
                  <td colSpan="8">
                    <div className="episodelist-table-loader">
                      Something went wrong
                    </div>
                  </td>
                </tr>
              ) : dataToDisplay?.length > 0 ? (
                dataToDisplay.map((r, ruleindex) => (
                  <tr key={r?.code_assist_rule_id || ruleindex}>
                    <td>
                      <button
                        type="button"
                        className="testRules-rule-id"
                        onClick={() => onViewRule && onViewRule(r)}
                      >
                        {r?.rule_id ? r?.rule_id : "No rule id"}
                      </button>
                    </td>
                    {/* r?.description ? r?.description */}

                    <td>
                      <Tooltip title={r?.description || "No description provided"}>
                        <span>
                          {r?.description
                            ? r?.description.length > 30
                          ? `${r?.description.slice(0, 30)}...`
                            : r?.description
                            : "No description provided"}
    </span>
  </Tooltip>
</td>

                     <td>
                                            <span className="viewRuleDb-pathway-tag">{r?.pathway_entry?.type}</span> 
                                            {/* {entry.value} */}
                                            <Tooltip title={r?.pathway_entry?.value || "No entry point"}>
                                              <span>
                                                {r?.pathway_entry?.value
                                                  ? r?.pathway_entry?.value.length > 20
                                                    ? `${r?.pathway_entry?.value.slice(0, 20)}...`
                                                    : r?.pathway_entry?.value
                                                  : "-"}
                                              </span>
                                            </Tooltip>
                                          </td>

                    <td className="testRules-trigger-codes">
                      {r?.trigger_codes?.length > 0
                        ? r.trigger_codes.map((trigger, index) => (
                            <span key={`${trigger?.code}-${index}`}>
                              {trigger?.code}
                              {index < r.trigger_codes.length - 1 ? ", " : ""}
                            </span>
                          ))
                        : "No trigger code provided"}
                    </td>

                    <td className="testRules-created-by">
                      {r?.created_by || "-"}
                    </td>
                      <td>{formatDate(r.created_at) || "-"}</td>


                    {/* <td>{r?.created_at || "-"}</td> */}

                    <td>
                      <StatusBadge status={r?.status} />
                    </td>

                    <td className="testRules-td-action">
                      <ActionMenu
                        rowId={r?.code_assist_rule_id || ruleindex}   
                        openId={openActionMenuId}                     
                        setOpenId={setOpenActionMenuId}  
                        status={r?.status}
                        onTestRule={() => {
                          // dispatch(
                            // getTestRuleDetails({
                            //   code_assist_manual_rule_id:
                            //     r?.code_assist_rule_id,
                            // }),
                          // );
                          JSON.stringify(sessionStorage.setItem("test-rule-id", r?.code_assist_rule_id));
                          navigate("/test-rule-details");
                        }}
                        onViewRule={() => {
                           const queryParams = new URLSearchParams({
                          code_assist_manual_rule_id: r?.code_assist_rule_id,
                          isViewPage: true,
                        });
                        navigate(`/failed-rule-details?${queryParams.toString()}`);
                        }}
                        onEditRule={() => {
                          const queryParams = new URLSearchParams({
                          code_assist_manual_rule_id: r?.code_assist_rule_id,
                          isEditPage: true,
                        });
                        navigate(`/failed-rule-edit?${queryParams.toString()}`);
                        }}
                        onDelete={async () => {
                          try {
                            const ruleId = r?.code_assist_rule_id;

                            if (!ruleId) {
                              toast.error(
                                "Unable to delete rule. Rule ID is missing.",
                              );
                              return;
                            }

                            const result = await dispatch(
                              deleteTestRule({
                                code_assist_manual_rule_id: ruleId,
                              }),
                            );

                            if (deleteTestRule.rejected.match(result)) {
                              toast.error(
                                result?.payload?.message ||
                                  result?.error?.message ||
                                  "Failed to delete rule.",
                              );
                              return;
                            }

                          const jobId = result?.payload?.job_id;
                          if (!jobId) {
                        toast.error(
                "Rule delete request was successful, but the job ID was not returned.",
      );
      return;
    }

    // Open the same status modal in loading state
    setRuleStatusResponse(null);
    setPublishModalType("loading");
    setShowPublishModal(true);

    // Start polling
    pollRuleStatus(jobId);
                          } catch (error) {
                            console.error("Delete rule error:", error);
                            toast.error(
                              "Something went wrong while deleting the rule.",
                            );
                          }
                        }}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8">
                    <div className="episodelist-table-loader">
                      No rules found
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Footer / pagination — stays pinned outside the scroll area */}
        <div className="testRules-footer">
          <span className="testRules-footer-text">
            Showing {startRule} to {endRule} of {totalAllRulesCount} rules
          </span>

          <div className="testRules-pagination">
            <button
              type="button"
              className="testRules-page-btn"
              disabled={currentRulePage <= 1 || totalAllRulesCount === 0}
              onClick={() => {
                const prevBtnPayload = {
                  ...allTestRulesPayload,
                  page_number: currentRulePage - 1,
                };

                dispatch(getAllTestRules(prevBtnPayload));
                dispatch(setTestRuleFilters(prevBtnPayload));
              }}
            >
              Prev
            </button>

            <button
              type="button"
              className="testRules-page-btn"
              disabled={
                currentRulePage >= totalRulesPages || totalAllRulesCount === 0
              }
              onClick={() => {
                const nextBtnPayload = {
                  ...allTestRulesPayload,
                  page_number: currentRulePage + 1,
                };

                dispatch(getAllTestRules(nextBtnPayload));
                dispatch(setTestRuleFilters(nextBtnPayload));
              }}
            >
              Next
            </button>
          </div>
        </div>
      </div>
      <PublishStatusModal
  show={showPublishModal}
  type={publishModalType}
  environment={[]}
  resultItems={ruleStatusResponse?.items || []}

  title="Rule Delete Information"
  loadingTitle="Deleting Rule"
  successTitle="Rule Deleted Successfully"

  loadingMessage="Your rule is being deleted."
  successMessage="Your rule has been successfully deleted."

  loadingInfoMessage="Please do not close or refresh this page while the rule is being deleted."

  failedTitle="Rule Delete Failed"
  failedMessage="We couldn't delete the rule."
  failedInfoMessage="Please review the details and try again."

  onClose={async () => {
    setShowPublishModal(false);

    const currentPage =
      allTestRulesData?.page_number || 1;

    const totalCount =
      allTestRulesData?.total_count || 0;

    const pageSize = 10;

    const updatedTotalCount = Math.max(
      totalCount - 1,
      0,
    );

    const lastPage = Math.max(
      1,
      Math.ceil(updatedTotalCount / pageSize),
    );

    const nextPage = Math.min(
      currentPage,
      lastPage,
    );

    const payload = {
      ...allTestRulesPayload,
      page_number: nextPage,
    };

    await dispatch(
      getAllTestRules(payload),
    ).unwrap();

    dispatch(setTestRuleFilters(payload));
  }}
/>
    </div>
  );
}
